<template>
<div class="rt-navbar navbar navbar-classic navbar-top py-3">
    <div class="rt-container rt-header__top-area user-personal-bar">

        <div class="align-items-center autofit-row">
			<b-row>
				<b-col md="3">
				<a accesskey="H" class="logo custom-logo rt-header__site-logo d-md-inline-flex" href="http://www.regione.toscana.it/home" title="Vai a ">
					<img alt="Regione Toscana" src="@/assets/logo-rt.png">
				</a>
				</b-col>
				
				<b-col md="9">
					<div class="autofit-col autofit-col-expand rt-header__social">
						<!-- Header secondary nav and social share -->
						<div class="rt-secondary-menu" style="float: right">
							<ul class="rt-secondary-menu__list">
								<li class="rt-secondary-menu__item"><a tabindex="0" title="Vai alla pagina Uffici" href="http://www.regione.toscana.it/uffici">Uffici</a></li>
								<li class="rt-secondary-menu__item"><a tabindex="0" target="_blank" title="Vai alla pagina URP" href="http://www.regione.toscana.it/urp">URP</a></li>
								<li class="rt-secondary-menu__item"><a tabindex="0" title="Vai alla pagina PEC" href="http://www.regione.toscana.it/-/posta-elettronica-certificata-pec">PEC</a></li>
								<li class="rt-secondary-menu__item"><a tabindex="0" title="Vai alla pagina Mappa del sito" href="http://www.regione.toscana.it/mappa">Mappa del sito</a></li>
								<li class="rt-secondary-menu__item"><a tabindex="0" title="Vai alla pagina Amministrazione trasparente" href="http://www.regione.toscana.it/regione/amministrazione-trasparente">Amministrazione trasparente</a></li>
								<li class="rt-secondary-menu__item"><a tabindex="0" title="Vai alla pagina Intranet" target="_blank" href="https://intranet.regione.toscana.it/">Intranet</a></li>
								<li class="rt-secondary-menu__item rt-secondary-menu__item-tn"><a tabindex="0" title="Toscana Notizie" aria-label="Toscana Notizie" href="https://www.toscana-notizie.it/"><img alt="Toscana Notizie" src="https://www.regione.toscana.it/o/regione-toscana-theme/images/toscana-notizie-logo-menu.png" srcset="https://www.regione.toscana.it/o/regione-toscana-theme/images/toscana-notizie-logo-menu@2x.png 2x"></a></li>
							</ul>
						</div>
						
						<div class="rt-social-media social-media-wrapper">
							<h2 class="rt-social-media__title">seguici su</h2>
							<ul class="rt-social-media__list">
								<li id="facebook" class="rt-social-media__item">
									<a title="Vai alla pagina Facebook" target="_blank" href="https://www.facebook.com/regionetoscana.paginaufficiale/" class="rt-social-media-icon rt-social-media-icon__facebook">
										<font-awesome-icon :icon="['fab', 'facebook-f']" />
										<span class="hide">Facebook</span>
									</a>
								</li>
								<li id="twitter" class="rt-social-media__item">
									<a title="Vai al profilo Twitter" target="_blank" href="https://twitter.com/regionetoscana" class="rt-social-media-icon rt-social-media-icon__twitter">
										<font-awesome-icon :icon="['fab', 'twitter']" />
										<span class="hide">Twitter</span>
									</a>
								</li>
								<li id="instagram" class="rt-social-media__item">
									<a title="Vai al proflo Instagram" target="_blank" href="https://www.instagram.com/regionetoscana/?hl=en" class="rt-social-media-icon rt-social-media-icon__instagram">
										<font-awesome-icon :icon="['fab', 'instagram']" />
										<span class="hide">Instagram</span>
									</a>
								</li>
								<li id="telegram" class="rt-social-media__item">
									<a title="Vai al profilo Telegram" target="_blank" href="https://t.me/regionetoscanaufficiale" class="rt-social-media-icon rt-social-media-icon__telegram">
										<font-awesome-icon :icon="['fab', 'telegram']" />
										<span class="hide">Telegram</span>
									</a>
								</li>
								<li id="flikr" class="rt-social-media__item">
									<a title="Vai al canale Flickr" target="_blank" href="https://www.flickr.com/photos/regionetoscana/albums" class="rt-social-media-icon rt-social-media-icon__flickr">
										<font-awesome-icon :icon="['fab', 'flickr']" />
										<span class="hide">Flickr</span>
									</a>
								</li>
								<li id="youtube" class="rt-social-media__item">
									<a title="Vai al canale Youtube" target="_blank" href="https://www.youtube.com/c/RegioneToscanaUfficiale" class="rt-social-media-icon rt-social-media-icon__youtube">
										<font-awesome-icon :icon="['fab', 'youtube']" />
										<span class="hide">Youtube</span>
									</a>
								</li>
							</ul>
						</div>
						<!-- END // Header secondary nav and social share -->
					</div>
				</b-col>
			</b-row>
        </div>
    </div>
</div>

</template>

<script>
export default {
  name: "RTHeader"
};
</script>

<style scoped>
	.hide {
		display: none;
	}

	.rt-secondary-menu__item a.rt-social-media-icon:hover {
		color: white;
	}
</style>
